const processOrderProducts = (headers, invoiceItems, payload, transData) => {
  let getHeaders = ''
  let getContent = ''
  for (let i = 0; i < headers.length; i++) {
    if (headers[i].value === 'qty' || headers[i].value === 'price' || headers[i].value === 'discount' || headers[i].value === 'vat' || headers[i].value === 'total' || headers[i].value === 'dg') getHeaders += `<th class="th-fontsize text-right" width="${headers[i].width}">${headers[i].text}</th>`
    else getHeaders += `<th class="th-fontsize" width="${headers[i].width}">${headers[i].text}</th>`
  }
  for (let j = 0; j < invoiceItems.length; j++) {
    getContent += '<tr>'
    for (let i = 0; i < headers.length; i++) {
      if (headers[i].value === 'qty' || headers[i].value === 'price' || headers[i].value === 'discount' || headers[i].value === 'vat' || headers[i].value === 'total' || headers[i].value === 'dg') {
        getContent += `<td class="th-fontsize text-right">${invoiceItems[j][headers[i].value] || ''}</td>`
      } else if (headers[i].value === 'product_name') {
        getContent += `<td class="th-fontsize">
          ${invoiceItems[j][headers[i].value] || ''} <br />
          ${invoiceItems[j].comments || ''}
        </td>`
      } else getContent += `<td class="th-fontsize">${invoiceItems[j][headers[i].value] || ''}</td>`
    }
    getContent += '</tr>'
  }
  return content(getHeaders, getContent, payload, transData)
}
const content = (headers, content, payload, transData) => btoa(unescape(encodeURIComponent(`<!DOCTYPE html>
<html>
  <head>
    <meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
    <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">
    <style>
    .footer {
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      text-align: center;
    }
    tbody tr { page-break-inside:avoid; }
    tbody tr td { word-break: break-word; }
    </style>
  </head>
  <body>
  <div class="container-fluid">
    <br><br>
    <div class="row">
      <div class="col-xs-6">
        <h4>${transData.customer || ''}: ${payload.customername || ''}</h4>
        <span>${transData.deliveryaddress || ''}: </span>
        <div style="margin-left: 10px;">
          <span>${payload.customeraddress_address || ''}</span><br>
          <span>${payload.customeraddress_address2 || ''}</span><br>
          <span>${payload.customeraddress_postcode || ''} ${payload.customeraddress_city || ''}</span>
        </div>
        <h4>${transData.invoiceTo || ''}: ${payload.invoicetoname || ''}</h4>
        <span>${transData.invoiceAddress || ''}: </span>
        <div style="margin-left: 10px;">
          <span>${payload.invoiceto_address || ''}</span><br>
          <span>${payload.invoiceto_address2 || ''}</span><br>
          <span>${payload.invoiceto_postcode || ''} ${payload.invoiceto_city || ''}</span>
        </div>
      </div>
      <div class="col-xs-6">
        <img class="img-responsive pull-right" height="350" width="350" src="${process.env.VUE_APP_IMAGE_URL}/${process.env.VUE_APP_LOGO_NAME}" alt="rotostop">
      </div>
      <div class="col-xs-6">
        <h3 class="text-right">${transData.confirm}</h3>
        <hr style="margin: 1px;" />
        <table style="width: 100%">
          <tr>
            <td>${transData.number}:</td>
            <td class="text-right">${payload.number || ''}</td>
          </tr>
          <tr>
            <td>${transData.responsible}:</td>
            <td class="text-right">${payload.responsiblename || ''}</td>
          </tr>
          <tr>
            <td>${transData.contact}:</td>
            <td class="text-right">${payload.contactname || ''}</td>
          </tr>
          <tr>
            <td>${transData.yourreference}:</td>
            <td class="text-right">${payload.yourreference || ''}</td>
          </tr>
          <tr>
            <td>${transData.offerdate}:</td>
            <td class="text-right">${payload.offerdate || ''}</td>
          </tr>
          <tr>
            <td>${transData.orderdate}:</td>
            <td class="text-right">${payload.orderdate || ''}</td>
          </tr>
          <tr>
            <td>${transData.deliverydate}:</td>
            <td class="text-right">${payload.deliverydate || ''}</td>
          </tr>
          <tr>
            <td>${transData.shipment}:</td>
            <td class="text-right">${payload.shipmentname || ''}</td>
          </tr>
          <tr>
            <td>${transData.paymentTerm}:</td>
            <td class="text-right">${payload.customerpaymentterm ? `${payload.customerpaymentterm} ${transData.days}` : ''}</td>
          </tr>
        </table>
      </div>
      <div class="col-xs-12">
        <table class="table table-condensed" style="width: 100%">
          <tbody>
            <tr>
              ${headers}
            </tr>
            ${content}
          </tbody>
        </table>
      </div>
    <div class="col-xs-6"></div>
    <div class="col-xs-6">
      <table style="width: 75%" class="pull-right">
        <tr>
          <th colspan="2">
            <hr style="margin: 4px" />
          </th>
        </tr>
        <tr>
          <th width="75%">${transData.totalExVat}:</th>
          <td width="25%" class="text-right">${payload.totalexvat || ''}</td>
        </tr>
        <tr>
          <th width="75%">${transData.total}:</th>
          <td width="25%" class="text-right">${payload.totalsum || ''}</td>
        </tr>
        <tr>
          <th width="75%">${transData.totalDG} DG:</th>
          <td width="25%" class="text-right">${payload.dg || ''}</td>
        </tr>
      </table>
    </div>
    </div>
  </div>
</body>
</html>`)))
export default processOrderProducts
